import React, { useEffect, useState } from "react";

// Simple zoom-through transition: dark-green bg, logo mark scales from small to
// huge and flies past the screen, revealing the home page.
export default function Preloader({ onDone }) {
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setFade(true), 2500);
    const t2 = setTimeout(() => onDone && onDone(), 3100);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden"
      style={{
        background: "radial-gradient(circle at 50% 45%, #0c3f24 0%, #05261a 55%, #02100b 100%)",
        transition: "opacity 0.6s ease",
        opacity: fade ? 0 : 1,
        pointerEvents: fade ? "none" : "auto",
      }}
    >
      <img
        src="/favicon-r.png"
        alt="RoboQuess"
        style={{
          width: 170,
          height: 170,
          objectFit: "contain",
          filter: "drop-shadow(0 24px 70px rgba(0,0,0,0.55))",
          animation: "rq-zoom-through 2.9s cubic-bezier(0.5,0,0.85,0.35) forwards",
        }}
      />
    </div>
  );
}
